<template>
  <div>
    <version-form />
  </div>
</template>

<script>
import VersionForm from '../../components/ride-hailing/versions/components/version-form/VersionForm.vue'

export default {
  components: {
    VersionForm,
  },
}
</script>
